<button
    mat-fab
    class="action-button"
    [disabled]="disabled"
    (click)="action.emit($event)"
>
    <mat-icon>{{icon}}</mat-icon>
</button>
